import {Outlet} from 'react-router-dom';
import routerProvider from '@refinedev/react-router-v6';
import {Refine} from '@refinedev/core';
import dataProvider from '@/lib/refinedev/dataProvider';
import {authProvider} from '@/lib/refinedev/authProvider';
import accessControlProvider from '@/lib/refinedev/accessControlProvider';
import notificationProvider from '@/lib/refinedev/notificationProvider';
import { resources } from './resources';

export const RefineProvider = () => {
  return (
    <Refine
      options={{disableTelemetry: true}}
      dataProvider={dataProvider}
      routerProvider={routerProvider}
      authProvider={authProvider}
      accessControlProvider={accessControlProvider}
      notificationProvider={notificationProvider}
      resources={resources.map(res => res.resource)}>
      <Outlet />
    </Refine>
  );
};
